import * as React from 'react';

export const DigestVariableIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="url(#paint0_linear_15675_630988)"
      d="m8 2.5 4.75 2.75v5.5L8 13.5l-4.75-2.75v-5.5zM4.747 5.539 8 7.422l3.253-1.883L8 3.656zm-.497.868v3.767l3.25 1.881V8.288zm4.25 5.648 3.25-1.881V6.407L8.5 8.288z"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_15675_630988"
        x1="12.75"
        x2="1.867"
        y1="2.5"
        y2="11.899"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.232" stopColor="#FF884D"></stop>
        <stop offset="0.802" stopColor="#E300BD"></stop>
      </linearGradient>
    </defs>
  </svg>
);
